import "./add-company.scss";
import { EditOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { ErrorMessages, SidepanelStyles } from "constants/index";
import {
  RoleSubscriptionEnum,
  SubscriptionContext
} from "context/SubscriptionProvider";
import { useContext, useEffect, useMemo, useState } from "react";
import { getSubscriptionVendorSources } from "utils/utils";
import AddCompanyForm from "components/new-company-form/new-company-form";

enum DrawerTitle {
  ADD_COMPANY = "Add Company",
  COMPANY_DETAILS = "View Company Details",
  UPDATE_COMPANY = "Update Company Details"
}

export default function AddUpdateCompanyInfoModal(props: {
  setDrawerOpen: (open: boolean) => void;
  showDrawerOpen: boolean;
  companyInfo?: any;
  setCompanyInfo?: (...args: any[]) => any;
}) {
  const { setDrawerOpen, showDrawerOpen, companyInfo, setCompanyInfo } = props;
  const { subscriptionRole } = useContext(SubscriptionContext);
  const [editMode, setEditMode] = useState(false);

  const isEditingPermission = useMemo(() => {
    if (companyInfo) {
      const allSource = getSubscriptionVendorSources(companyInfo);
      if (!(allSource.length === 1 && allSource[0] === "ConstructivIQ"))
        return false;
    }
    return subscriptionRole > RoleSubscriptionEnum.subscription_viewer;
  }, [companyInfo, subscriptionRole]);

  const headerTitle = useMemo(() => {
    if (companyInfo) {
      return isEditingPermission
        ? DrawerTitle.UPDATE_COMPANY
        : DrawerTitle.COMPANY_DETAILS;
    }
    return DrawerTitle.ADD_COMPANY;
  }, [companyInfo, isEditingPermission]);

  useEffect(() => {
    if (companyInfo) setEditMode(false);
    else if (isEditingPermission) setEditMode(true);
  }, [companyInfo, isEditingPermission]);

  const onClose = () => {
    setDrawerOpen(false);
    if (setCompanyInfo) {
      setCompanyInfo(null);
    }
  };

  return (
    <Modal
      className="custom-drawer"
      title={
        <div
          className="flex justify-between items-center mr-8 h-5"
          data-testid="addcompany-modal"
        >
          <div data-testid="header-title">{headerTitle}</div>
          <Button
            className="border-none focus:border-none hover:border-none hover:bg-transparent"
            type="text"
            icon={<EditOutlined className="company-edit-icon" />}
            title={
              isEditingPermission ? "" : ErrorMessages.PermissionNotGranted
            }
            hidden={!companyInfo || editMode}
            disabled={!isEditingPermission}
            onClick={() => {
              setEditMode(true);
            }}
            data-testid="company-edit-pencil-icon"
          />
        </div>
      }
      width={420}
      style={SidepanelStyles.style}
      footer={<div className="py-4" />}
      open={showDrawerOpen}
      onCancel={onClose}
      destroyOnHidden
    >
      <AddCompanyForm
        editCompany={companyInfo}
        isFormEditOnly={editMode}
        onNewCompany={() => setDrawerOpen(false)}
        onUpdateCompany={() => setDrawerOpen(false)}
      />
    </Modal>
  );
}
